import { env } from "@bkry/bowline-utils";
const { REACT_APP_CDN_PATH } = env;

// ledger
export const ledgerArray = [
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/ledger/1.mp4",
    altText: "ledger",
    type: "video",
    key: 0,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/ledger/2.png",
    altText: "ledger",
    type: "img",
    key: 1,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/ledger/3.png",
    altText: "ledger",
    type: "img",
    key: 2,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/ledger/4.png",
    altText: "ledger",
    type: "img",
    key: 3,
  },
];

// wiami
export const wiamiArray = [
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/wiami/WW_01_800x800.png",
    altText: "wiami",
    type: "img",
    key: 0,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/wiami/WW_02_800x800.png",
    altText: "wiami",
    type: "img",
    key: 1,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/wiami/WW_03_800x800.png",
    altText: "wiami",
    type: "img",
    key: 2,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/wiami/WW_04_800x800.png",
    altText: "wiami",
    type: "img",
    key: 3,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/wiami/WW_05_800x800.png",
    altText: "wiami",
    type: "img",
    key: 4,
  },
];

// illuvium
export const illuviumArray = [
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/collabs/illuvium/600x600_Partner_Details_Illuvium_1.mp4",
    altText: "illuvium",
    type: "video",
    key: 0,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/collabs/illuvium/600x600_Partner_Details_Illuvium_2.mp4",
    altText: "illuvium",
    type: "video",
    key: 1,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/collabs/illuvium/600x600_Partner_Details_Illuvium_3.mp4",
    altText: "illuvium",
    type: "video",
    key: 2,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/collabs/illuvium/600x600_Partner_Details_Illuvium_4.mp4",
    altText: "illuvium",
    type: "video",
    key: 3,
  },
];

// wow
export const wowArray = [
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/wow/add-image-1.png",
    altText: "wow",
    type: "img",
    key: 0,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/wow/add-image-2.mp4",
    altText: "wow",
    type: "video",
    key: 0,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/wow/add-image-3.png",
    altText: "wow",
    type: "img",
    key: 0,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/wow/add-image-4.mp4",
    altText: "wow",
    type: "video",
    key: 0,
  },
];

// belvedere
export const belvedereArray = [
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/belvedere/1.mp4",
    altText: "belvedere",
    type: "video",
    key: 0,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/belvedere/2.mp4",
    altText: "belvedere",
    type: "video",
    key: 1,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/belvedere/3.mp4",
    altText: "belvedere",
    type: "video",
    key: 2,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/belvedere/4.jpg",
    altText: "belvedere",
    type: "img",
    key: 3,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/belvedere/5.png",
    altText: "belvedere",
    type: "img",
    key: 4,
  },
  {
    src: (REACT_APP_CDN_PATH || "") + "/images/collabs/belvedere/6.jpg",
    altText: "belvedere",
    type: "img",
    key: 5,
  },
];

// polygonlabs
export const polygonlabsArray = [
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/collabs/polygonlabs/Polygon_Gallery01.png",
    altText: "polygonlabs",
    type: "img",
    key: 0,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/collabs/polygonlabs/Polygon_Gallery02.png",
    altText: "polygonlabs",
    type: "img",
    key: 1,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/collabs/polygonlabs/Polygon_Gallery03.png",
    altText: "polygonlabs",
    type: "img",
    key: 2,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/collabs/polygonlabs/Polygon_Gallery04.png",
    altText: "polygonlabs",
    type: "img",
    key: 3,
  },
  {
    src:
      (REACT_APP_CDN_PATH || "") +
      "/images/collabs/polygonlabs/Polygon_Gallery05.png",
    altText: "polygonlabs",
    type: "img",
    key: 4,
  },
];
